import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import { useParams } from "react-router-dom";
import LoadingScreen from "../../organisms/LoadingScreen";
import { useQuery } from "@tanstack/react-query";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import { Button, Card, Col, Row } from "react-bootstrap";
import styled from "styled-components";
import CardTitle from "../../organisms/CardTitle";
import { buscarPorId, QUERY_BUSCAR_AGENDAMIENTO_SPA_POR_ID } from "../../../services/agendamientosSpaServicios";
import { AgendamientoResumidoSpa } from "../../agendamientoResumido/AgendamientoResumidoSpa";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/reservas",
    label: "Reservas por Tipo",
  },
  {
    path: "/reservas/spa",
    label: "Reserva Spa",
  },
  {
    path: "/reservas/spa/ver",
    label: "Ver",
    isActive: true,
  }
];

function MostrarAgendamientoSpa() {
  let { idAgendamiento } = useParams();

  const {
    data: agendamiento,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [QUERY_BUSCAR_AGENDAMIENTO_SPA_POR_ID],
    enabled: idAgendamiento !== undefined,
    queryFn: async () =>
      await buscarPorId(idAgendamiento || '')
  });

  const urlCancelacion = `/reservas/spa/${idAgendamiento}/cancelar`;

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isError) {
    return <ServerErrorModal />;
  }

  return (
    <>
      <Page
        title="Visualizar Agendamiento de Spa"
        description="Visualización y cancelación de agendamiento."
        breadCrumbs={breadCrumbs}
      >
        {agendamiento && (
          <Row className="justify-content-center">
            <div className="col-xs-12 col-md-12 col-lg-8 col-xxl-6">
              <StyledCard>
                <StyledCardHeader className="mt-3 mb-3">
                  <CardTitle>{"Detalles de Agendamiento"}</CardTitle>
                </StyledCardHeader>
                <StyledCardBody>
                  <AgendamientoResumidoSpa agendamiento={agendamiento} />
                  <Row>
                    <Col className="gap-2 d-flex justify-content-center">
                      <Button href="/reservas/spa/listar">Ver Listado</Button>
                      <Button href={`/ventas/${agendamiento.idVenta}`}>Ver Venta</Button>
                      {
                          agendamiento.estaActivo && (
                            <Button variant="danger" href={urlCancelacion}>Cancelar Agendamiento</Button>
                          )
                      }
                    </Col>
                  </Row>
                </StyledCardBody>
              </StyledCard>
            </div>
          </Row>
        )}
      </Page>
    </>
  );
}

const StyledCard = styled(Card)`
  margin-bottom: 1.875rem;
  background-color: #fff;
  transition: all 0.5s ease-in-out;
  position: relative;
  border: 0px solid transparent;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 13px 0px rgb(82 63 105 / 5%);
`;

const StyledCardBody = styled(Card.Body)`
  padding: 1.25rem;
`;

const StyledCardHeader = styled(Card.Header)`
  border-color: #eaeaea;
  position: relative;
  background-color: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0px;
`;

export default MostrarAgendamientoSpa;
